import { render, staticRenderFns } from "./personalSetting.vue?vue&type=template&id=4c335b8a&lang=pug"
import script from "./personalSetting.vue?vue&type=script&lang=js"
export * from "./personalSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports